export const UPDATE_ROLE = 'USER/UPDATE_ROLE';
export const UPDATE_FIRST_NAME = 'USER/UPDATE_FIRST_NAME';
export const UPDATE_LAST_NAME = 'USER/UPDATE_LAST_NAME';
export const UPDATE_EMAIL = 'USER/UPDATE_EMAIL';
export const UPDATE_PHONE = 'USER/UPDATE_PHONE';
export const UPDATE_LOCATIONS = 'USER/UPDATE_LOCATIONS';

export const SET_USER = 'USER/SET_USER';
export const RESET_USER = 'USER/RESET_USER';
